// extracted by mini-css-extract-plugin
export default {"deficiency-type":"deficiency-type_deficiency-type__xqjpz"};